import { render } from "./CambiarPass.vue?vue&type=template&id=613a9322&scoped=true"
import script from "./CambiarPass.vue?vue&type=script&lang=js"
export * from "./CambiarPass.vue?vue&type=script&lang=js"

import "./CambiarPass.vue?vue&type=style&index=0&id=613a9322&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613a9322"]])

export default __exports__